// inspired by https://stackoverflow.com/a/3561711
const pattern = /[.*+?^${}()|[\]\\]/g;

export default (string) => {
    return string.replace(pattern, "\\$&");
};
